module.exports = __webpack_public_path__ + "img/ps.58f4bad3.png";